import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import {theme} from './theme'

const container = document.getElementById("root")!;
const root = createRoot(container);

const persistor = persistStore(store)

root.render(
  <ChakraProvider theme={theme}>
    <React.StrictMode>
      <Provider store={store}>
        <Router>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Router>
      </Provider>
    </React.StrictMode>
  </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



// const theme = extendTheme({
//   colors: {
//     primary: {
//       100: "#e8f2fa",
//       200: "#bad9ef",
//       300: "#8dc0e4",
//       400: "#5fa7d9",
//       500: "#318ece",
//       600: "#266fa0",
//       700: "#1b4f72",
//       800: "#102f45",
//       900: "#051017",
//     },
//   },
  
// });
